import styled from 'styled-components/macro'
import { Icon } from 'assets/Icons_'
import { iso_free, iso_isrotating } from 'state/store.global'
import { useAtom } from 'state/jotai'
import { useBreak } from 'hooks/useBreak'
import { BREAK_ } from 'constants'

export const Back = ({}) => {
  const [rmode, setRmode] = useAtom(iso_free)
  const [isrotate, setIsrotate] = useAtom(iso_isrotating)
  const isMobile = useBreak('md_dn')
  const click = () => {
    setRmode(false)
    setIsrotate(false)
  }


  return (
    <Box onClick={click}> 
      <Icon icon='back' size={isMobile ? '18' : '18'} color='#000' />
      <Text>Tilbage</Text>
    </Box>
  )
}

const Text = styled.div`
  white-space: nowrap;
  font-size: 18px;
  font-weight: 400px;  
  /* border: 1px solid black; */
`
const Box = styled.div`
  gap: 5px;
  cursor: pointer;
  padding: 5px 15px;
  z-index: 5;
  align-items: center;
  display: flex;
  gap:5px;
  user-select:none;
  ${ BREAK_.md_up } {
    position: absolute;
    top: 105px;
    left: 40px;
    padding:0;
  }
`